import dayjs, { Dayjs } from "dayjs";

export const columns = {
  HAS_APPOINTMENT: {
    id: "HAS_APPOINTMENT",
    title: "Has Appointment",
  },
  ARRIVED: {
    id: "ARRIVED",
    title: "Arrived",
  },
  IN_PROGRESS: {
    id: "IN_PROGRESS",
    title: "In Progress",
  },
  WAITING_FOR_XRAY: {
    id: "WAITING_FOR_XRAY",
    title: "Waiting For XRAY",
  },
  IN_XRAY: {
    id: "IN_XRAY",
    title: "In XRAY",
  },
  DONE: {
    id: "DONE",
    title: "Done",
  },
  PAID: {
    id: "PAID",
    title: "Paid",
  },
};

export const columnOrder = [
  "HAS_APPOINTMENT",
  "ARRIVED",
  "IN_PROGRESS",
  "WAITING_FOR_XRAY",
  "IN_XRAY",
  "DONE",
  "PAID",
];
export type ColumnType = {
  id: string;
  title: string;
  // appointmentIds: string[];
};
export type AppointmentType = {
  id: string;
  PatientName: string;
  appointmentStartTime: Dayjs;
  appointmentLastUpdatedTime: Dayjs;
  status: string;
};
